import { MESSAGE_TYPES } from './events';

export const emit = (selector: Host.SelectorElement, payload: App.IPayloadData): void => {
	let el: Host.WCElement | null = null;

	if (typeof selector === 'string') {
		el = window.document.querySelector(selector);
	} else {
		el = selector;
	}

	if (el) {
		const { vueComponent } = el;

		vueComponent && vueComponent.emit(payload);
	}
};

export const emitWrap =
	(selector: Host.SelectorElement): Host.EmitWrap =>
	(payload: App.IPayloadData): void =>
		emit(selector, payload);

export const emitNavigation = (selector: Host.SelectorElement, payload: App.IPayloadData): void => {
	emit(selector, { ...payload, type: MESSAGE_TYPES.NAVIGATION });
};

export const emitNotification = (selector: Host.SelectorElement, message: unknown): void => {
	emit(selector, { data: message, type: MESSAGE_TYPES.NOTIFICATION });
};

export const emitNavigationWrap =
	(selector: Host.SelectorElement): Host.EmitWrap =>
	(payload: App.IPayloadData): void =>
		emitNavigation(selector, payload);

export const emitNotificationWrap =
	(selector: Host.SelectorElement): Host.EmitWrap =>
	(message: unknown): void =>
		emitNotification(selector, message);
